export const LOGO_IMPROVEMENT_FLOW_ACTIVE =
  process.env.VUE_APP_LOGO_IMPROVEMENT_FLOW_ACTIVE === 'true';
export const CONTINUE_WITH_CURRENT_LOGO = 'Continue with current logo';
export const REQUEST_LOGO_IMPROVEMENTS = 'Request logo improvements';
export const SELECT_REVISED_LOGO = 'Select a revised logo or upload a new one';

export const IMPROVEMENT_OPTIONS = [
  { enlargeSmallElements: 'Enlarge small elements' },
  { simplifyDesign: 'Simplify design' },
  { changeFontToMoreReadable: 'Change font to more readable' },
  { refineEdges: 'Refine edges' },
  { thickenLogoElements: 'Thicken logo elements' },
  { removeProblematicElements: 'Remove problematic elements' },
  {
    updateToCurrentTechnicalRequirements:
      'Update to current technical requirements',
  },
];
